import ColorSelectionOption from "../base/option/ColorSelectionOption";
import Color from "../base/option/Color";
import Lang from "../global/Lang";

enum UserRole {
  GUEST = "GUEST",
  USER = "USER",
  ADMINISTRATOR = "ADMINISTRATOR",
}

enum UserPhone {
  BIND = "BIND",
  UNBIND = "UNBIND",
}

let UserRoles: UserRole[] = Object.keys(UserRole).map((k) => k as UserRole);

let UserRoleMap: { [key in keyof typeof UserRole]: ColorSelectionOption } = {
  GUEST: {
    name: Lang.t("user.roleGuest"),
    value: "GUEST",
    color: Color.WARNING,
  },
  USER: {
    name: Lang.t("user.roleUser"),
    value: "USER",
    color: Color.PRIMARY,
  },
  ADMINISTRATOR: {
    name: Lang.t("user.roleAdministrator"),
    value: "ADMINISTRATOR",
    color: Color.DANGER,
  },
};

let UserPhoneMap: { [key in keyof typeof UserPhone]: ColorSelectionOption } = {
  BIND: {
    name: Lang.t("user.bind"),
    value: "BIND",
    color: Color.DANGER,
  },
  UNBIND: {
    name: Lang.t("user.unbind"),
    value: "UNBIND",
    color: Color.INFO,
  },
};

let UserRoleList: ColorSelectionOption[] = [];
UserRoles.forEach((type: UserRole, index: number) => {
  UserRoleList.push(UserRoleMap[type]);
});

export { UserRole, UserRoles, UserRoleMap, UserRoleList, UserPhoneMap };
